import React from 'react';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import './summary-section.css';

const SummarySection = (props) => {
  const {
    title,
    summaryText,
  } = props;
  return (
    <div className="summary-section padding-top-bottom-24">
      <SummaryDetails
        summaryTitle={title}
        summaryText={summaryText}
      />
    </div>
  );
};

export default SummarySection;
